<h2 class="text-center">Provider Authentication</h2>
<p>Please enter your third party username and password to link your accounts.</p>

<fgbcl-errors></fgbcl-errors>

<div class="form-group">
  <label for="username">Username</label>
  <input type="text" class="form-control" id="username" [(ngModel)]="username" />
</div>

<div class="form-group">
  <label for="password">Password</label>
  <input type="password" class="form-control" id="password" [(ngModel)]="password" />
</div>

<fgb-registration-navigation (nextButtonClicked)="submitStep()" [stepType]="stepType"></fgb-registration-navigation>
